import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { AllStockTakeLotFieldsFragmentDoc } from '../../../_lib/__generated__/stock-take-lots-fragment.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OngoingStockTakeQueryVariables = Types.Exact<{
  stockTakeId: Types.Scalars['ID'];
  facilityId: Types.Scalars['ID'];
  input?: Types.InputMaybe<Types.StockTakeLotsInput>;
  options?: Types.InputMaybe<Types.StockTakeLotsOptions>;
}>;


export type OngoingStockTakeQuery = { readonly __typename?: 'Query', readonly stockTake?: { readonly __typename?: 'StockTake', readonly id: string, readonly locationId: string, readonly lots: { readonly __typename?: 'StockTakeLotsPage', readonly items: ReadonlyArray<{ readonly __typename?: 'StockTakeLotAddition', readonly id: string, readonly name: string, readonly expiryDate: string, readonly lastStockTakeAt?: string | null, readonly additionReviewQuantity: number, readonly additionQuantityDifference: number, readonly additionLot?: { readonly __typename?: 'StockTakePartialLot', readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } | null } | { readonly __typename?: 'StockTakeLotUpdate', readonly id: string, readonly name: string, readonly reviewedQuantity?: number | null, readonly initialQuantity: number, readonly quantityDifference: number, readonly lastStockTakeAt?: string | null, readonly lot: { readonly __typename?: 'StockTakePartialLot', readonly expiryDate: string, readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } }> }, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number } } | null };


export const OngoingStockTakeDocument = gql`
    query ongoingStockTake($stockTakeId: ID!, $facilityId: ID!, $input: StockTakeLotsInput, $options: StockTakeLotsOptions) {
  stockTake(input: {stockTakeId: $stockTakeId, facilityId: $facilityId}) {
    id
    locationId
    lots(input: $input, options: $options) {
      items {
        ...AllStockTakeLotFields
      }
    }
    aggregateInfo {
      totalLotCount
      reviewedLotCount
    }
  }
}
    ${AllStockTakeLotFieldsFragmentDoc}`;

/**
 * __useOngoingStockTakeQuery__
 *
 * To run a query within a React component, call `useOngoingStockTakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOngoingStockTakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOngoingStockTakeQuery({
 *   variables: {
 *      stockTakeId: // value for 'stockTakeId'
 *      facilityId: // value for 'facilityId'
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useOngoingStockTakeQuery(baseOptions: Apollo.QueryHookOptions<OngoingStockTakeQuery, OngoingStockTakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OngoingStockTakeQuery, OngoingStockTakeQueryVariables>(OngoingStockTakeDocument, options);
      }
export function useOngoingStockTakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OngoingStockTakeQuery, OngoingStockTakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OngoingStockTakeQuery, OngoingStockTakeQueryVariables>(OngoingStockTakeDocument, options);
        }
export type OngoingStockTakeQueryHookResult = ReturnType<typeof useOngoingStockTakeQuery>;
export type OngoingStockTakeLazyQueryHookResult = ReturnType<typeof useOngoingStockTakeLazyQuery>;
export type OngoingStockTakeQueryResult = Apollo.QueryResult<OngoingStockTakeQuery, OngoingStockTakeQueryVariables>;